<template>
  <v-alert
    :value="alertComp"
    :type="type"
    dark
    transition="scale-transition"
    @input="inputAlert"
    dismissible
  >
    <div v-if="value && value.length > 0">
      <div v-for="(item, i) in value" :key="i">{{item}}</div>
    </div>
  </v-alert>
</template>

<script>
export default {
  props: {
    value: {
      default: () => {
        return [];
      }
    },
    type: {}
  },
  data() {
    return {
      alert: false,
      values: []
    };
  },

  computed: {
    alertComp() {
      if (!this.value || this.value.length == 0) {
        this.changeAlert(false);
        return false;
      } else {
        this.changeAlert(true);
        return true;
      }
    }
  },
  watch: {
    value() {
      this.$forceUpdate();
    }
    // "value.length"(value) {
    //   if (value && value > 0) this.alert = true;
    //   else this.alert = false;
    // },
    // value(value) {
    //   console.log("mudou");
    //   if (value == null || value.length == 0) {
    //     this.alert = false;
    //   } else {
    //     this.alert = true;
    //   }
    // }
  },
  methods: {
    changeAlert(value) {
      this.alert = value;
    },
    inputAlert() {
      this.$emit("input", []);
      this.alert = false;
    }
  }
};
</script>